/**
 * Navigation outside of React.
 *
 * Sagas and the AI action executors need to navigate, but they live outside the
 * component tree. This used to be `connected-react-router`, which dispatched
 * navigation as redux actions. React Router v7 owns navigation itself, so we
 * keep a reference to the router instance and drive it directly.
 *
 * The reference is set once in `src/index.js`, right after the router is
 * created and before it is rendered.
 */

let router = null;

export const setRouter = (routerInstance) => {
  router = routerInstance;
};

/**
 * Navigate from outside React. Mirrors `navigate()` from `useNavigate`, so
 * `navigate('/x')`, `navigate('/x', { replace: true })` and
 * `navigate('/x', { state })` all work.
 */
export const navigate = (to, options) => {
  if (!router) {
    // Navigation before the router exists would be a silent no-op that is very
    // hard to trace, so make it loud instead of swallowing it.
    console.warn(`Navigation to "${to}" was ignored: the router is not ready.`);
    return undefined;
  }

  return router.navigate(to, options);
};

/**
 * The current location, for code that used to read `state.router.location`
 * from the `connected-react-router` reducer.
 */
export const getLocation = () => router?.state?.location;
